var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_31712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1275 41.7252C16.5408 40.8151 15.4688 39.1054 15.4688 37.1484C15.4688 29.0712 22.0399 22.5 30.1172 22.5H36.1537L36.4379 17.8125H2.23383L4.69066 58.3484C4.74691 59.2762 5.51566 60 6.44531 60H17.2312C16.1252 58.5301 15.4688 56.7036 15.4688 54.7266C15.4688 52.4473 16.9226 50.5014 18.9514 49.7667C18.2323 48.664 17.8125 47.3491 17.8125 45.9375C17.8125 44.5243 18.2332 43.2082 18.9537 42.1046C18.3806 41.9755 18.0625 41.8487 18.1275 41.7252ZM19.3341 14.2973C19.3355 14.2973 19.3369 14.2969 19.3383 14.2969H36.9141C37.885 14.2969 38.6719 13.51 38.6719 12.5391C38.6719 11.5682 37.885 10.7812 36.9141 10.7812H22.581L27.3193 3.51562H33.3984C34.3693 3.51562 35.1562 2.72871 35.1562 1.75781C35.1562 0.786914 34.3693 9.38546e-08 33.3984 9.38546e-08H26.3672C26.0748 -9.54697e-05 25.787 0.0727882 25.53 0.212043C25.2729 0.351297 25.0546 0.552518 24.895 0.797461L18.3838 10.7812H1.75781C0.786914 10.7812 0 11.5682 0 12.5391C0 13.51 0.786914 14.2969 1.75781 14.2969H19.3277C19.3301 14.2969 19.3323 14.2973 19.3341 14.2973Z",
    fill: "#8A49D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9844 37.1484C18.9844 38.1193 19.7713 38.9062 20.7422 38.9062H58.2422C59.2131 38.9062 60 38.1193 60 37.1484C60 31.0098 55.0058 26.0156 48.8672 26.0156H30.1172C23.9786 26.0156 18.9844 31.0098 18.9844 37.1484ZM24.8438 42.4219C22.902 42.4219 21.3281 43.9957 21.3281 45.9375C21.3281 47.8793 22.902 49.4531 24.8438 49.4531H54.1406C56.0824 49.4531 57.6562 47.8793 57.6562 45.9375C57.6562 43.9957 56.0824 42.4219 54.1406 42.4219H24.8438ZM58.2422 52.9688H20.7422C19.7713 52.9688 18.9844 53.7557 18.9844 54.7266C18.9844 57.6343 21.3502 60 24.2578 60H54.7266C57.6343 60 60 57.6342 60 54.7266C60 53.7557 59.2131 52.9688 58.2422 52.9688Z",
    fill: "#8A49D6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_31712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.52c4952e16bbab3c19ec4a50d0abadd5.svg";
export { ForwardRef as ReactComponent };